import { memo } from 'react'
import { PriceProps } from './Price.types'
import { usePrice } from './Price.hooks'

function Price(props: PriceProps) {
  const { price } = usePrice(props)
  return <>{price}</>
}

export default memo(Price)
